"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M3 8.753a1.97 1.97 0 0 1 1.582-1.93l.48-.096a3 3 0 0 1 2.133.37l.292.175a3 3 0 0 0 1.544.428H12a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.044 4.754H7.45a1.6 1.6 0 0 0-1.6 1.6h-1.4a3 3 0 0 1 3-3h.594a2.9 2.9 0 0 1 1.675.532 2.9 2.9 0 0 0 1.675.532H15a3 3 0 0 1 3 3v3.776a3 3 0 0 1-3 3v-1.4a1.6 1.6 0 0 0 1.6-1.6V7.418a1.6 1.6 0 0 0-1.6-1.6h-3.606a4.3 4.3 0 0 1-2.483-.79 1.5 1.5 0 0 0-.867-.274"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.595 7.205H5a1.6 1.6 0 0 0-1.6 1.6v4.84a1.6 1.6 0 0 0 1.6 1.6h7.55a1.6 1.6 0 0 0 1.6-1.6V9.87a1.6 1.6 0 0 0-1.6-1.6H8.944a4.3 4.3 0 0 1-2.483-.79 1.5 1.5 0 0 0-.866-.275M5 5.805h.595a2.9 2.9 0 0 1 1.675.533 2.9 2.9 0 0 0 1.674.532h3.606a3 3 0 0 1 3 3v3.776a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-4.84a3 3 0 0 1 3-3",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.253 10.638a1.045 1.045 0 1 0 2.091 0 1.045 1.045 0 0 0-2.09 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.435 13.67c0-.77.624-1.394 1.393-1.394H7.7c.77 0 1.394.624 1.394 1.394a.35.35 0 0 1-.348.348H5.783a.35.35 0 0 1-.348-.348m4.405.348h1.94a.35.35 0 0 0 .349-.348c0-.77-.624-1.394-1.394-1.394h-.871q-.2.001-.382.053c.282.373.449.838.449 1.341 0 .16-.032.272-.09.348"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.785 14.017a.35.35 0 0 1-.315-.347c0-.333.117-.64.312-.879.195.24.312.546.312.88a.349.349 0 0 1-.31.346"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.217 10.638a1.045 1.045 0 1 0 2.09 0 1.045 1.045 0 0 0-2.09 0",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ProjectIcon20.js.map